import { useMemo } from "react";
import { find } from "lodash-es";
import { PriceChangePercentage } from "../components/Chat/Cards/type";
import { genForecastLineData } from "../utils/stock";
import { Rating } from "../features/api/openData";
import { getTranslateData, LOCALES } from "../utils";

type IUseTokenDetailsHandleProps = {
  tokenList: any;
  symbol?: string;
  initialData?: any;
  locale?: string;
};

export const useTokenDetailsHandle = (props: IUseTokenDetailsHandleProps) => {
  const { tokenList, initialData, locale = LOCALES.EN } = props;
  // const tokenData = tokenList?.find((item: any) => item.symbol === symbol);
  // const tokenData = tokenList?.find((item: any) => item.id === id);
  const tokenData = tokenList?.[0] || initialData;
  const {
    market_data,
    addresses,
    total_supply,
    max_supply,
    circulating_supply,
    holder,
    desc,
    multi_language_desc,
    logo,
    name,
    issue_date,
    team_members,
    investors,
    sentiment,
    twitter_handle,
    website,
    social_media,
    symbol,
    target_price,
    ohlc,

    // 获取pool数据
    base_symbol,
    base_address,
    dex_id,
    address,
  } = tokenData || {};
  const latest_rating = tokenData?.latest_rating as Rating;

  const [sentimentPercentage, isShowBullish] = useMemo(() => {
    const bullishCount =
      find(sentiment, (item: any) => item.sentiment === "BULLISH")?.count || 0;
    const bearishCount =
      find(sentiment, (item: any) => item.sentiment === "BEARISH")?.count || 0;

    const totalCount = bullishCount + bearishCount || 1;
    const isShowBullish = totalCount >= 50;
    return [Math.round((bullishCount / totalCount) * 100), isShowBullish];
  }, [sentiment]);

  const {
    current_price,
    price_change_percentage: priceChangeList,
    market_cap,
    fdv,
    volume_24h,
    txns_24h,
    liquidity,
    marker_24h,
  } = market_data || {};

  const holderCount = holder?.count || 0;

  const priceChangePercentage24h = priceChangeList?.find(
    (item: PriceChangePercentage) => item.time_period === "24h",
  )?.percentage;

  const twitterLink =
    social_media?.twitter || twitter_handle
      ? [
          {
            link: social_media?.twitter || `https://x.com/${twitter_handle}`,
            icon: "https://ipfs.opensocial.co/ipfs/QmWGqptRy1cFh9niZZ5jHf4ccnwUZnxXCRDWNsMSTKHZfa",
            iconName: "X-logo",
          },
        ]
      : [];
  const websiteLink =
    social_media?.website || website
      ? [
          {
            link: social_media?.website || website || "",
            icon: "https://ipfs.opensocial.co/ipfs/QmRVus7hJhvmgJVJRmrdJJmExBPNLKfF13VK5V34EgjBGM",
            iconName: "globe",
          },
        ]
      : [];

  const socialMedias = [...twitterLink, ...websiteLink];
  const formatInvestors = investors?.map((item: any) => ({
    ...item,
    avatar: item.avatar,
    name: item.display_name,
  }));

  const forecastLineData = useMemo(() => {
    if (Array.isArray(ohlc) && ohlc.length > 0) {
      const { XAxis, YAxisData, ticks } = genForecastLineData(ohlc, {
        handleXLabel: (date) => date.format("MMM DD YYYY"),
        handleTickLabel: (date) => date.format("MMM DD YYYY"),
      });
      return { XAxis, YAxis: YAxisData, ticks };
    }
    return { XAxis: [], YAxis: [], ticks: [] };
  }, [ohlc]);

  const language_desc = getTranslateData({
    locale,
    languageData: multi_language_desc,
  });

  return {
    marketData: market_data,
    currentPrice: current_price,
    priceChangeList: priceChangeList,
    priceChangePercentage24h,
    marketCap: market_cap,
    fdv,
    totalSupply: total_supply,
    maxSupply: max_supply,
    circulatingSupply: circulating_supply,
    holderCount,
    holder,
    desc,
    language_desc,
    forecastLineData,
    issueDate: issue_date,
    volume24h: volume_24h,
    teamMembers: team_members,
    investors: formatInvestors,
    sentiment: sentiment,
    logo,
    sentimentPercentage,
    isShowBullish,
    addresses,
    baseAddress: base_address,
    pollAddress: address,
    socialMedias,
    name,
    symbol: symbol || base_symbol,
    dexId: dex_id,
    txns24h: txns_24h,
    marker24h: marker_24h,
    liquidity,
    latest_rating,
    themes: tokenData?.themes,
    rateData: {
      rate: tokenData?.latest_rating?.level?.final,
      id: tokenData?.id,
      symbol: tokenData?.symbol,
    },
    targetPrice: target_price,
    ohlcv: ohlc,
    tokenData,
  };
};
